module.exports = __webpack_public_path__ + "img/shopee_9thb_0011.75f5803c.png";